import {css} from "@emotion/css";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import {RouteInfo} from "../../route/RouteHelper";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import RaikoCustomTable from "../../raikoComponents/raikoCustomTable/RaikoCustomTable";
import React, {useEffect, useState} from "react";
import RaikoBaseContainer from "../../raikoComponents/raikoBaseContainer/RaikoBaseContainer";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import {managerAccessLevelHeader, prepareManagerAccessLevelTableRow} from "../../component/manangerDetail/ManagerAccessLevelTable";
import RaikoDefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import {ManagerAccessLevelDetail} from "../../component/managerAccessLevelDetail/ManagerAccessLevelDetail";
import {ManagerAccessLevelService} from "../../serverService/managerAccessLevelService/ManagerAccessLevelService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {Helmet} from "react-helmet";

export const ManagerAccessLevelList = () => {

    const size = 10

    let page = 0
    const [accessLevelSelectedItemId, setAccessLevelSelectedItemId] = useState(-1);

    const service = new ManagerAccessLevelService()

    const snackbarDispatch = useSnackbarDispatcher();
    const snackbar = new SnackbarHelper(snackbarDispatch)

    const [tableLoading, setTableLoading] = useState(false);
    const [accessList, setAccessList] = useState([]);
    const [pageCount, setPageCount] = useState(0);

    const [isNeedRefreshList, setIsNeedRefreshList] = useState(false);




    useEffect(() => {
        if (service) {
            getDataFromServer()
        }
    }, [])

    function getDataFromServer() {
        setTableLoading(true)
        service.getAccessLevelList(page, size)
            .then(response => {
                setPageCount(response.totalPage)
                const _list = []
                response.data.map((item, index) => {
                    _list.push(
                        prepareManagerAccessLevelTableRow(item.id, page * size + index + 1, item.name, item.name)
                    )
                })

                setAccessList(_list)

                setTableLoading(false)
            }).catch(reason => {
            setTableLoading(false)
            snackbar.showErrorMessage(
                new ServerErrorHandler(reason).getMessage("خطا در دریافت اطلاعات")
            )
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function handleAddNewAccessLevel() {
        handleOpenAccessDialog();
    }

    function handleShowAccessDetail(itemId) {
        setAccessLevelSelectedItemId(itemId)
        handleOpenAccessDialog();
    }

    const [accessLevelDialogOpenState, setAccessLevelDialogOpenState] = useState(false);

    function handleCloseAccessLevelDialog() {
        setAccessLevelSelectedItemId(-1)
        setAccessLevelDialogOpenState(false)
        if (isNeedRefreshList) {
            setIsNeedRefreshList(false)
            page = 0
            getDataFromServer()
        }
    }

    function handleOpenAccessDialog() {
        setAccessLevelDialogOpenState(true)
    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.ManagersAccess.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseAccessLevelDialog}
                open={accessLevelDialogOpenState}
                pageTitle={"جزئیات دسترسی"}
                dialogSize={DialogSize.LARGE}
            >
                <ManagerAccessLevelDetail
                    accessSelectedItemId={accessLevelSelectedItemId}
                    changeNeedRefresh={setIsNeedRefreshList}
                />
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>

                <RaikoBreadcrumb
                    breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            "مدیریت",
                            ""
                        ),
                        raikoBreadCrumbItemGenerator(
                            RouteInfo.ManagersAccess.name,
                            ""
                        ),
                    ]}/>

                <RaikoBaseCardContainer className={`${css`
                  margin-top: 40px;
                `}`}>
                    <div className={css`
                      display: flex;
                      flex-direction: row;
                      flex-wrap: nowrap;
                      justify-content: end;
                      align-items: center;
                      align-content: center;
                      gap: 16px;
                      padding: 0 16px;
                    `}>
                        {/*<RaikoMaterialOutlinedInput
                            labelText={"جست و جو"}
                            className="flex-grow-1"
                            spellCheck={false}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <div className={"search-icon"}/>
                                    </InputAdornment>
                                ),
                            }}
                            placeHolder={"عبارت مورد نظر خود را وارد نمایید."}
                        />*/}
                        <ButtonPrimaryRaiko
                            label={"افزودن"}
                            className={css`height: max-content !important;`}
                            onClick={handleAddNewAccessLevel}
                        />
                    </div>
                    <div className={css`
                      width: 100%;
                      margin-top: 1rem;
                      overflow-x: scroll`}>
                        <RaikoCustomTable
                            isLoading={tableLoading}
                            data={accessList}
                            header={managerAccessLevelHeader}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            rowClicked={handleShowAccessDetail}
                        />
                    </div>

                </RaikoBaseCardContainer>

            </RaikoBaseContainer>

        </>
    )
}

